import { connect } from 'react-redux';
import { getAnnualResults } from '../../selectors';
import LineSavings from './LineSavings';

import { setSelectedFinancing } from '../../../../../common/settings/actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    ppaRate: state.ppa.rate,
    ppaEscalator: state.ppa.escalator,
    loanTerm: state.loan.term,
    downPayment: state.loan.downPayment,
    loanInterest: state.loan.interest,
    cashprice: state.solar.cashprice,
    systemSize: state.solar.systemSize,
    formattedSystemPrice: state.solar.systemSize,
    provider: state.utility.provider,
    energyValue: state.utility.energyValue,
    annualInflation: state.utility.annualInflation,
    doughnutSlider: state.settings.doughnutSlider,
    showPPA: state.ppa.showPPA,
    showLoan: state.loan.showLoan,
    loanProvider: state.loan.loanProvider,
    showOBS: state.obs.showOBS,
    showCAP: state.cap.showCAP,
    resiToggle: state.tax.resiToggle,
    includeCash: state.cash.includeCash,
    setSelectedFinancing,
});

const combinedActions = {
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(LineSavings);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/LineSavings/index.js